module.exports = __webpack_public_path__ + "media/09_point-blank.e2c5c39d.mp3";